export * from './admin.service';
import { AdminService } from './admin.service';
export * from './cRM.service';
import { CRMService } from './cRM.service';
export * from './easyRegistration.service';
import { EasyRegistrationService } from './easyRegistration.service';
export * from './public.service';
import { PublicService } from './public.service';
export * from './suppliers.service';
import { SuppliersService } from './suppliers.service';
export * from './upload.service';
import { UploadService } from './upload.service';
export * from './user.service';
import { UserService } from './user.service';
export const APIS = [AdminService, CRMService, EasyRegistrationService, PublicService, SuppliersService, UploadService, UserService];
